import apollo from '@/graphql'

import AddDeviceOperation from '@/graphql/device_operation/AddDeviceOperation.gql'
import DevicesQuery from '@/graphql/device/DevicesQuery.gql'
import ListIdDevices from '@/graphql/device/ListIdDevices.gql'
import PaginatedDevicesQuery from '@/graphql/device/PaginatedDevicesQuery.gql'
import HardwareVersionsQuery from '@/graphql/hardware/HardwareVersionsQuery.gql'
import UnassignedDevicesQuery from '@/graphql/device/UnassignedDevicesQuery.gql'

// initial state
const state = {
  devices: [],
  listIdDevices: [],
  loadingLoadDevices: false,
  paginatedDevices: {
    devices: [],
  },
  hardware: [],
  unassignedDevices: [],
  hardwareVersions: [],
}

// getters
const getters = {
  devices: st => st.devices,
  listIdDevices: st => st.listIdDevices,
  loadingLoadDevices: st => st.loadingLoadDevices,
  paginatedDevices: st => st.paginatedDevices,
  unassignedDevices: st => st.unassignedDevices,
  hardwareVersions: st => st.hardwareVersions,
}

const mutations = {
  setDevices(st, devices) {
    state.devices = devices
  },

  setPaginatedDevices(st, paginatedDevices) {
    state.paginatedDevices = paginatedDevices
  },

  setHardwareVersions(st, hardwareVersions) {
    state.hardwareVersions = hardwareVersions
  },

  setUnassignedDevices(st, unassignedDevices) {
    state.unassignedDevices = unassignedDevices
  },

  setLoadingLoadDevices(state, loading) {
    state.loadingLoadDevices = loading
  },
  setListIdDevices(state, listIdDevices) {
    state.listIdDevices = listIdDevices
  },
}

// actions
const actions = {
  async loadPaginatedDevices({ commit }, { variables }) {
    const { data: { paginatedDevices } } = await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: PaginatedDevicesQuery,
        variables,
      })

    commit('setPaginatedDevices', paginatedDevices)
  },

  loadDevices({ commit }) {
    apollo.defaultClient
      .watchQuery({
        query: DevicesQuery,
      })
      .subscribe(({ data: { devices } }) => {
        commit('setDevices', devices)
      })
  },

  loadListIdDevices({ commit }, { search }) {
    commit('setLoadingLoadDevices', true)
    apollo.defaultClient
      .watchQuery({
        query: ListIdDevices,
        variables: { search, page: 1, pageSize: 400 },
      })
      .subscribe(({ data: { listIdDevices } }) => {
        commit('setListIdDevices', listIdDevices)
        commit('setLoadingLoadDevices', false)
      })
  },

  loadHardwareVersions({ commit }) {
    apollo.defaultClient
      .watchQuery({
        query: HardwareVersionsQuery,
      })
      .subscribe(({ data: { hardwareVersions } }) => {
        commit('setHardwareVersions', hardwareVersions)
      })
  },

  loadUnassignedDevices({ commit }) {
    return apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: UnassignedDevicesQuery,
      })
      .then(({ data: { unassignedDevices } }) => {
        commit('setUnassignedDevices', unassignedDevices)
      })
  },

  sendDevicesCommands(context, { $message, devicesCommand }) {
    apollo.defaultClient
      .mutate({
        mutation: AddDeviceOperation,
        variables: {
          fields: devicesCommand,
        },
      })
      .then(() => {
        $message({
          message: `The "${
            devicesCommand.command
          }" action was sent to device(s)`,
          type: 'success',
        })
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/device/DeviceList.js